import PaymentMethodsCard from '../payment-method/PaymentMethodsCard.vue';

export default [
  {
    path: 'payment-methods',
    component: PaymentMethodsCard,
  },
  {
    path: 'customers/:customerId/payment-methods',
    component: PaymentMethodsCard,
    props: true,
  },
];
